import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Input } from 'reactstrap'

const PhoneField = ({
  value,
  onChange,
  placeholder,
  disabled = false,
  invalid = false,
  name,
  id,
  ...props
}) => {
  const [displayValue, setDisplayValue] = useState(value || '')

  useEffect(() => {
    setDisplayValue(value || '')
  }, [value])

  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return ''
    
    // Remove all non-numeric characters
    const cleaned = phoneNumber.replace(/\D/g, '')
    
    // Limit to 11 digits max (Brazilian phone numbers)
    const limited = cleaned.substring(0, 11)
    
    // Apply Brazilian phone number formatting
    if (limited.length <= 10) {
      // Landline format: (11) 1234-5678
      if (limited.length >= 7) {
        return limited.replace(/^(\d{2})(\d{4})(\d+)/, '($1) $2-$3')
      } else if (limited.length >= 3) {
        return limited.replace(/^(\d{2})(\d+)/, '($1) $2')
      } else if (limited.length >= 1) {
        return limited.replace(/^(\d+)/, '($1')
      }
    } else {
      // Mobile format: (11) 91234-5678
      return limited.replace(/^(\d{2})(\d{5})(\d+)/, '($1) $2-$3')
    }
    
    return limited
  }

  const handleChange = (e) => {
    const inputValue = e.target.value
    const formatted = formatPhoneNumber(inputValue)
    
    setDisplayValue(formatted)
    
    // Call onChange with formatted value
    onChange({
      target: {
        name: name,
        value: formatted
      }
    })
  }

  return (
    <Input
      type="tel"
      inputMode="tel"
      autoComplete="tel-national"
      id={id}
      name={name}
      value={displayValue}
      onChange={handleChange}
      placeholder={placeholder}
      invalid={invalid}
      disabled={disabled}
      maxLength={15}
      {...props}
    />
  )
}

PhoneField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  name: PropTypes.string.isRequired,
  id: PropTypes.string
}

export default PhoneField